/* @flow */

import type { Storage } from "crustate";
import type { Client } from "@awardit/graphql-ast-client";
import type { RouteRequest, RouteResponse } from "@crossroads/shop-state/route";

import { ROUTE_REQUEST, ROUTE_RESPONSE } from "@crossroads/shop-state/route";
import { route } from "queries";

const registerClient = (storage: Storage, client: Client<{}>) => {
  storage.addEffect({
    effect: async (msg: RouteRequest) => {
      const response = await client(
        route,
        { path: msg.url.replace("/", "") },
        { cache: true });

      return ({
        tag: ROUTE_RESPONSE,
        data: response.route,
      }: RouteResponse);
    },
    subscribe: { [ROUTE_REQUEST]: true },
  });
};

export default registerClient;
